'use strict';

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

import React, { Component } from 'react';
import PropTypes from 'prop-types';

import RibbonSpeciesIcon from '../view/RibbonSpeciesIcon';

var GenericRibbonSubjectLabel = function (_Component) {
  _inherits(GenericRibbonSubjectLabel, _Component);

  function GenericRibbonSubjectLabel(props) {
    _classCallCheck(this, GenericRibbonSubjectLabel);

    var _this = _possibleConstructorReturn(this, _Component.call(this, props));

    _this.prefixToSpecies = {
      'HGNC': 'Homo sapiens', // human
      'UniProtKB': 'Homo sapiens', // human
      'MGI': 'Mus musculus', // mouse
      'RGD': 'Rattus norvegicus', // rat
      'ZFIN': 'Danio rerio', // zebrafish
      'FB': 'Drosophila melanogaster', // fly
      'FlyBase': 'Drosophila melanogaster', // fly
      'WB': 'Caenorhabditis elegans', // worm
      'SGD': 'Saccharomyces cerevisiae' // yeast
    };

    _this.state = {
      subjectId: props.subjectId,
      subjectLabel: props.subjectLabel,
      subjectTaxon: props.subjectTaxon,
      subjectBaseURL: props.subjectBaseURL,
      useTaxonIcon: props.useTaxonIcon,
      hide: props.hide,
      newTab: props.newTab
    };
    return _this;
  }

  GenericRibbonSubjectLabel.prototype.componentDidMount = function componentDidMount() {};

  GenericRibbonSubjectLabel.prototype.shouldComponentUpdate = function shouldComponentUpdate(nextProps, nextState) {
    return true;
  };

  GenericRibbonSubjectLabel.prototype.componentDidUpdate = function componentDidUpdate(prevProps, prevState, snapshot) {};

  GenericRibbonSubjectLabel.prototype.getSubjectID = function getSubjectID() {
    if (this.state.subjectBaseURL.includes("amigo.geneontology.org")) {
      return this.state.subjectId.replace("MGI:", "MGI:MGI:");
    }
    return this.state.subjectId;
  };

  GenericRibbonSubjectLabel.prototype.render = function render() {
    return React.createElement(
      'div',
      { className: !this.state.hide ? 'ontology-ribbon__item__subject' : '',
        title: this.state.subjectLabel + (this.state.subjectTaxon ? " (" + this.state.subjectTaxon + ")" : "")
      },
      this.state.subjectBaseURL ? React.createElement(
        'a',
        { href: this.state.subjectBaseURL + this.getSubjectID(), className: 'ontology-ribbon__label ribbon-link', target: this.state.newTab ? '_blank' : '_self' },
        this.state.useTaxonIcon ? React.createElement(
          'span',
          null,
          React.createElement(RibbonSpeciesIcon, { species: this.getPrefixForId(this.state.subjectId) }),
          ' ',
          this.state.subjectLabel
        ) : this.state.subjectLabel + "(" + this.species3LCode(this.state.subjectTaxon) + ")"
      ) : React.createElement(
        'span',
        null,
        this.state.useTaxonIcon ? React.createElement(
          'span',
          null,
          React.createElement(RibbonSpeciesIcon, { species: this.getPrefixForId(this.state.subjectId) }),
          ' ',
          this.state.subjectLabel
        ) : this.state.subjectLabel + "(" + this.species3LCode(this.state.subjectTaxon) + ")"
      )
    );
  };

  GenericRibbonSubjectLabel.prototype.species3LCode = function species3LCode(species) {
    console.log('receive: ', species);
    var split = species.split("\s");
    return split[0].charAt(0) + split[1].substring(1, 3);
  };

  GenericRibbonSubjectLabel.prototype.getPrefixForId = function getPrefixForId(inputId) {
    var idSplit = inputId.split(':');
    if (idSplit.length === 0) return null;
    return this.prefixToSpecies[idSplit[0]];
  };

  return GenericRibbonSubjectLabel;
}(Component);

GenericRibbonSubjectLabel.propTypes = process.env.NODE_ENV !== "production" ? {
  subjectId: PropTypes.string.isRequired,
  subjectLabel: PropTypes.string.isRequired,
  subjectBaseURL: PropTypes.string,
  subjectTaxon: PropTypes.string,
  useTaxonIcon: PropTypes.bool,
  hide: PropTypes.bool,
  newTab: PropTypes.bool
} : {};

GenericRibbonSubjectLabel.defaultProps = {
  hide: false,
  newTab: PropTypes.bool
};

export default GenericRibbonSubjectLabel;